import React from 'react';
import styled from 'styled-components';

function Triangle(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <polygon points="50,0 100,100 0,100" />
    </svg>
  );
}

const Wrapper = styled.a`
  position: relative;
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  &:hover .triangle-bg {
    transform: translate(-50%, -50%) scale(1);
  }
`;

interface TriangleBgProps {
  color?: string;
}

export const TriangleBg = styled(Triangle)<TriangleBgProps>`
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  z-index: 0;

  fill: ${(props) => props.color || '#ff0055'};

  transform: translate(-50%, -50%) scale(0) rotate(-45deg);
  transform-origin: center;

  transition: transform 350ms cubic-bezier(0.22, 1, 0.36, 1);
`;

export const Icon = styled.span`
  display: flex;
  position: relative;
  z-index: 1;
`;

interface SocialIconProps {
  href: string;
  children: React.ReactNode;
  triangleColor?: string;
}

export function SocialIcon({ href, children, triangleColor }: SocialIconProps) {
  return (
    <Wrapper href={href} target="_blank" rel="noreferrer">
      <TriangleBg className="triangle-bg" color={triangleColor} />
      <Icon>{children}</Icon>
    </Wrapper>
  );
}
